import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ItemsProps } from "../../types/item";
import { GET } from "../../services/axios.service";
import { ProcessesProps } from "../../types/process";
import { JobworkPartiesItemProps, JobworkPartiesProps } from "../../types/jobworkParties";
import { RootState } from "../../app/store";

export interface JobworkPartiesItemState {
  isJobworkPartiesItemModalOpen: boolean;
  jobworkParty: JobworkPartiesProps | null;
  jobworkPartiesItem: JobworkPartiesItemProps[];
  items: ItemsProps[];
  processes: ProcessesProps[];
  loading: boolean;
  error: string | null;
}

const initialState: JobworkPartiesItemState = {
  isJobworkPartiesItemModalOpen: false,
  jobworkParty: null,
  jobworkPartiesItem: [],
  items: [],
  processes: [],
  loading: false,
  error: null,
};

export const fetchItemsList = createAsyncThunk(
  "fetchItemsListForJobworkPartyItem",
  async () => {
    let response: any;
    await GET(`/v1/admin/items`, { all: true })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const fetchProcessesList = createAsyncThunk(
  "fetchProcessesListForJobworkPartyItem",
  async () => {
    let response: any;
    await GET(`/v1/admin/processes`, { all: true })
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const fetchJobworkPartiesItemListData = createAsyncThunk(
  "fetchJobworkPartiesItemListData",
  async (id: number) => {
    let response: any;
    await GET(`/v1/admin/jobwork-parties/${id}/items`, {})
      .then((res: any) => {
        response = res;
      })
      .catch((err) => {
        response = err;
      });
    return response;
  }
);

export const jobworkPartiesItemSlice = createSlice({
  name: "jobworkPartiesItem",
  initialState,
  reducers: {
    toggleJobworkPartiesItemModal: (state, action: PayloadAction<boolean>) => {
      state.isJobworkPartiesItemModalOpen = action.payload;
      if (!action.payload) {
        state.jobworkParty = null;
        state.jobworkPartiesItem = [];
        state.items = [];
        state.processes = [];
      }
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchItemsList.pending, (state, action: any) => {
      state.items = [];
    });
    builder.addCase(fetchItemsList.fulfilled, (state, action: any) => {
      if (action.payload.data.status === "success") {
        state.items = action.payload.data.data.records;
      } else {
        state.items = [];
      }
    });
    builder.addCase(fetchItemsList.rejected, (state, action: any) => {
      state.items = [];
    });
    builder.addCase(fetchProcessesList.pending, (state, action: any) => {
      state.processes = [];
    });
    builder.addCase(fetchProcessesList.fulfilled, (state, action: any) => {
      if (action.payload.data.status === "success") {
        state.processes = action.payload.data.data.records;
      } else {
        state.processes = [];
      }
    });
    builder.addCase(fetchProcessesList.rejected, (state, action: any) => {
      state.processes = [];
    });
    builder.addCase(fetchJobworkPartiesItemListData.pending, (state, action: any) => {
      state.jobworkParty = null;
      state.jobworkPartiesItem = [];
      state.loading = true;
      state.error = null;
    });
    builder.addCase(
      fetchJobworkPartiesItemListData.fulfilled,
      (state, action: any) => {
        state.loading = false;
        if (action.payload.data.status === "success") {
          state.jobworkParty = action.payload.data.data.party_info;
          state.jobworkPartiesItem = action.payload.data.data.party_items;
          state.error = null;
        } else {
          state.jobworkParty = null;
          state.jobworkPartiesItem = [];
          state.error =
            action?.payload?.data?.message ||
            "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
        }
      }
    );
    builder.addCase(fetchJobworkPartiesItemListData.rejected, (state, action: any) => {
      state.jobworkParty = null;
      state.jobworkPartiesItem = [];
      state.loading = false;
      state.error =
        action?.payload?.data?.message ||
        "કંઈક ખોટું ગયું, કૃપા કરીને ફરીથી પ્રયત્ન કરો.";
    });
  },
});

export const { toggleJobworkPartiesItemModal } = jobworkPartiesItemSlice.actions;

export const getJobworkParty = (state: RootState) => state.jobworkPartiesItem.jobworkParty;

export const getItems = (state: RootState) => state.jobworkPartiesItem.items;

export const getProcesses = (state: RootState) => state.jobworkPartiesItem.processes;

export const getJobworkPartiesItem = (state: RootState) =>
  state.jobworkPartiesItem.jobworkPartiesItem;

export const getIsJobworkPartiesItemModalOpen = (state: RootState) =>
  state.jobworkPartiesItem.isJobworkPartiesItemModalOpen;

export default jobworkPartiesItemSlice.reducer;
